module.exports = __webpack_public_path__ + "static/media/thierry-mugler-alien-big.e4ce7483.png";